import { useTranslation } from 'react-i18next';
import { ProhibitedItems } from '../../../models/prohibitedItems';
import {
  ProhibitedListItemContainer,
  ProhibitedListItemDescriptionContainer,
  ProhibitedListItemDescription,
  ProhibitedListItemTagsContainer,
} from './prohibited-list-item.styles';
import { getProhibitedTags } from './helpers';
import Image from '../../../common/image-component/image.component';

interface Props {
  prohibitedItem: ProhibitedItems;
}

const ProhibitedListItem = ({ prohibitedItem }: Props) => {
  const { t } = useTranslation();
  const { icon, code, description, tags } = prohibitedItem;

  const prohibitedTags = getProhibitedTags(tags, t);

  return (
    <ProhibitedListItemContainer>
      <Image
        src={icon}
        alt={code}
        width='6rem'
        height='6rem'
        borderRadius='5px'
      />
      <ProhibitedListItemDescriptionContainer>
        <ProhibitedListItemDescription>
          {description}
        </ProhibitedListItemDescription>
        {prohibitedTags && (
          <ProhibitedListItemTagsContainer>
            {prohibitedTags}
          </ProhibitedListItemTagsContainer>
        )}
      </ProhibitedListItemDescriptionContainer>
    </ProhibitedListItemContainer>
  );
};

export default ProhibitedListItem;
